import classnames from 'classnames';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useCheckComplete } from '../../hook/use-check-complete';
import { useLogin } from '../../hook/use-login';
import { Images } from '../../images';
import type { CombineViewProps } from '../../types';
import { AccountStatus, ViewType } from '../../types';
import { Button } from '../../uikit/web/button';
import { Input } from '../../uikit/web/input';
import { Title } from '../../uikit/web/title';
import { clearTmpAccount, setTmpAccount, tmpAccount } from '../../utils';
import { cx } from '@flowus/common/cx';
import { DisplayType } from './login';
import { loginInjector } from '../../utils/init';

/**密码登录 */
export const PasswordLogin: FC<CombineViewProps> = (props) => {
  const {
    account,
    accountError,
    accountStatus,
    password,
    passwordError,
    setPassword,
    setAccount,
    loginByPassword,
  } = useLogin({
    account: sessionStorage.getItem(tmpAccount) ?? undefined,
    ...props,
    newInviteCode: props.inviteCode,
  });

  const allowLoginClick = account && password;
  const [showPassword, setShowPassword] = useState(false);
  const checkComplete = useCheckComplete(props.switchViewType);
  const { switchViewType } = props;

  useEffect(() => {
    if (accountStatus === AccountStatus.CAN_SIGN) {
      switchViewType({
        type: ViewType.LOGIN,
        props: {
          account,
          accountStatus: AccountStatus.CAN_SIGN,
          displayType: DisplayType.INPUT_VERIFY_CODE,
        },
      });
    }
  }, [account, accountStatus, switchViewType]);

  const onLogin = async () => {
    const user = await loginByPassword();
    if (!user) return;
    if (!props.complete || checkComplete(user)) {
      props.onSuccess?.(user);
    }
  };
  return (
    <>
      <Title
        className={cx('mb-7', props.titleClassName)}
        text={props.defaultTitle || '👋 欢迎回来'}
      />
      <div className="sm:px-5">
        <Input
          warning={accountError}
          className="t-input-account mb-5 h-[50px] w-full px-3 h-md:text-h4"
          autoFocus={true}
          value={account}
          placeholder="请输入手机号/邮箱"
          onChange={(v) => {
            setTmpAccount(v);
            setAccount(v);
          }}
        />
        <Input
          inputType={showPassword ? 'text' : 'password'}
          warning={passwordError}
          className="t-input-password mb-2.5 h-[50px] w-full px-3 h-md:text-h4"
          onEnter={() => onLogin()}
          value={password}
          placeholder={'请输入密码'}
          onChange={setPassword}
          addonAfter={
            <img
              src={showPassword ? Images.IcMenuItemHide : Images.IcMenuItemShow}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowPassword(!showPassword);
              }}
              className="absolute right-2.5 h-5 w-5 cursor-pointer text-grey3"
            />
          }
        />
        <div className="flex justify-end">
          <div
            className={cx('text-t2 cursor-pointer hover:opacity-80 text-grey3 pr-1', {
              hidden: loginInjector.noEmailService && loginInjector.noSMSService,
            })}
            onClick={() => {
              clearTmpAccount();
              props.switchViewType({
                type: ViewType.FORGET_PASSWORD,
              });
            }}
          >
            忘记密码?
          </div>
        </div>
        <Button
          onClick={onLogin}
          disable={!allowLoginClick}
          colorType="primary"
          className={classnames(
            't-btn-login text-t1-medium mt-7 h-[50px] w-full sm:mt-3 h-md:text-h4',
            {
              'opacity-30': !allowLoginClick,
            }
          )}
          size="auto"
        >
          登录
        </Button>
      </div>
    </>
  );
};
